import React, { useState } from "react";
import { Search } from "lucide-react";

const ActiveMember = [
  {
    id: "802",
    name: "Mr. G. Venkatesh/ Mr. M. Deepan",
    desc: "802",
    title: "",
    company: "M/s Sri M.S.T. Smelters Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-g-venkatesh-mr-m-deepan.jpg",
  },
  {
    id: "816",
    name: "Mr. Sudhir Goyal, Director",
    desc: "816",
    title: "",
    company: "M/s Madhav Alloys Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-sudhir-goyal.jpg",
  },
  {
    id: "AF-39",
    name: "Mr. Gulu M. Advani",
    desc: "AF-39",
    title: "",
    company: "M/s Elektromag Devices (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "812",
    name: "Mr. Mool Chand Aggarwal",
    desc: "812",
    title: "",
    company: "M/s SMC Power Generation Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "671",
    name: "Mr. Mukesh Agarwal",
    desc: "671",
    title: "",
    company: "M/s Suryadev Alloys & Power (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-mukesh-agarwal.jpg",
  },
  {
    id: "748",
    name: "Mr. Nimit Gupta",
    desc: "748",
    title: "",
    company: "M/s Oasis Enterprises Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-72",
    name: "Mr. Dhawal Khemchand Shah (Dir)",
    desc: "AF-72",
    title: "",
    company: "M/s Metco Marketing (India) Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-06",
    name: "Mr. Mithilesh Giri",
    desc: "AF-06",
    title: "",
    company: "M/s Shiva Consultancy Services P. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "458",
    name: "Mr. Krishna Kumar Binani(KW)",
    desc: "458",
    title: "Executive Director",
    company: "M/s Electrosteel Castings Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-26",
    name: "Mr. M.K. Sheshadri/ Mr. K.R. Ashok",
    desc: "AF-26",
    title: "",
    company:
      "M/s Tata Steel Long Products Limited (Formerly Tata Sponge Iron Limited)",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "352",
    name: "Mr. Vinod Kumar Goyal",
    desc: "352",
    title: "",
    company: "M/s Sant Gyaneshwar Steels Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-vinod-kumar-goyal.jpg",
  },
  {
    id: "129",
    name: "Mr. R.L. Gupta",
    desc: "129",
    title: "",
    company: "M/s R.L. Steels & Energy Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "821",
    name: "Mr. Divyanshu Bansal, MD",
    desc: "821",
    title: "",
    company: "M/s Shivangi Rolling Mills Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "811",
    name: "Mr. Dinesh Chandra Mittal",
    desc: "811",
    title: "",
    company: "M/s Mittal Coin Pvt. Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "285",
    name: "Mr. T. Suthanthirarajan",
    desc: "285",
    title: "",
    company: "M/s Sri Vinayaga Alloys Pvt Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-40",
    name: "Mr. Saurabh Kedia",
    desc: "AF-40",
    title: "",
    company: "M/s Cellpap India Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "674",
    name: "Mr. Sri Nivas Gupta",
    desc: "674",
    title: "",
    company: "M/s Shree Krishna Rolling Mills (Jaipur) Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/shri-niwas-gupta.jpg",
  },
  {
    id: "784",
    name: "Mr. Devendra Kumar Agrawal (MD)",
    desc: "784",
    title: "",
    company: "M/s Kashi Vishwanath Steels Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "437",
    name: "Mr. Vijay Bansal",
    desc: "437",
    title: "",
    company: "M/s Bansal Alloys & Metals Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-vinay-bansal.jpg",
  },
  {
    id: "546",
    name: "Mr. S.S. Beriwala",
    desc: "546",
    title: "",
    company: "M/s Shyam Steel Industries Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "403",
    name: "Mr. Amit Burakia",
    desc: "403",
    title: "",
    company: "M/s Bhagwati Steel Cast Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-07",
    name: "Mr. Mukesh Bhandari, Chairman",
    desc: "AF-07",
    title: "",
    company: "M/s Electrotherm (India) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-mukesh-bhandari.jpg",
  },
  {
    id: "834",
    name: "Mr. S. S. Rathi, Director",
    desc: "834",
    title: "",
    company: "M/s Nalwa Steel And Power Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "837",
    name: "Mr. Dirsha K Mohammed",
    desc: "837",
    title: "Executive Director",
    company: "M/s Thieh Ingots Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF - 78",
    name: "Mr. Ankit Mittal/ Mr. Manak Modi",
    desc: "AF - 78",
    title: "",
    comapny: "M/s Mittal Appliances Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "783",
    name: "Shri Rajendra Goel",
    desc: "783",
    title: "",
    comapny: "M/s Shri Bajrang Power & Ispat Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "836",
    name: "Mr. Ramesh Iyer DVP-Head Development",
    desc: "836",
    title: "",
    comapny: "M/s Indian Commodity Exchange Limited (ICEX)",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "718",
    name: "Mr. Mayank Singhania (Dir)",
    desc: "718",
    title: "",
    comapny: "M/s Sun Metallics & Alloys Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "667",
    name: "Mr. Shital Agarwal (Dir)",
    desc: "667",
    title: "",
    comapny: "M/s Drolia Electrosteels (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "423",
    name: "Mr. Ashwani Bhatia",
    desc: "423",
    title: "",
    comapny: "M/s ARS Steel & Alloys International Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-ashwani-bhatia.jpg",
  },
  {
    id: "628",
    name: "Mr. Pavan Singhania",
    desc: "628",
    title: "",
    comapny: "M/s Jaideep Ispat & Alloys Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-pavan-singhania.jpg",
  },
  {
    id: "048",
    name: "Mr. M.K. Gupta",
    desc: "048",
    title: "",
    comapny: "M/s Starwire (INDIA) Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-mk-gupta.jpg",
  },
  {
    id: "558",
    name: "Mr. D.B. Soni",
    desc: "558",
    title: "",
    comapny: "M/s Meta Rolls & Commodities Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "527",
    name: "Mr. Sandeep Agarwal",
    desc: "527",
    title: "",
    comapny: "M/s Mohit Steel Industries Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-sandeep-agarwal.jpg",
  },
  {
    id: "AF - 84",
    name: "Mr. C.S. Sharma (Genral Mangr)",
    desc: "AF - 84",
    title: "",
    comapny: "M/s Oilex Exploration Supplies Private Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "801",
    name: "Mr. Harmesh Kumar Jain (Partner)",
    desc: "801",
    title: "",
    comapny: "M/s T C G Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "838",
    name: "Mr. Yogesh Mandhani Director",
    desc: "838",
    title: "",
    comapny: "M/s Mahalaxmi TMT Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "351",
    name: "Mr. Kapoor Singh Khatri",
    desc: "351",
    title: "",
    comapny: "M/s Sohn Steel Pvt. Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "318",
    name: "Mr. S. Chandrasekaran ",
    desc: "318",
    title: "Chief General Manager",
    comapny: "M/s Tulsyan Nec Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-64",
    name: "Mr. Rajesh Maheshwari",
    desc: "AF-64",
    title: "",
    comapny: "M/s Eros Envirotech Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "819",
    name: "Mr. Harshvardhan Mittal",
    desc: "819",
    title: "",
    comapny: "M/s Mohit Ispat Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "435",
    name: "Mr. Harsh Vardhan Mittal",
    desc: "435",
    title: "",
    comapny: "M/s West Coast Ingots Pvt Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-harsh-vardhan-mittal.jpg",
  },
  {
    id: "AF-89",
    name: "Mr. Bijoyen Das General Manager (Mktg.)",
    desc: "AF-89",
    title: "",
    comapny: "M/s Transformers and Rectifiers (India) Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "617",
    name: "Mr. Ghansham Goyal",
    desc: "617",
    title: "",
    comapny: "M/s Kalika Steel Alloys Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  // {
  //   id: "360",
  //   name: "Mr. Shanti Lal G.",
  //   desc: "360",
  //   title: "",
  //   comapny: "M/s SRJ Peety Steels (P) Ltd.",
  //   img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  // },
  {
    id: "354",
    name: "Mr. Jitendra P. Gandhi",
    desc: "354",
    title: "",
    comapny: "M/s Shri Karvir Nivasini Mahalaxmi Ispat Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "553",
    name: "Mr. Purushottam Kumar Gupta",
    desc: "553",
    title: "",
    comapny: "M/s Duggar Fiber Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "823",
    name: "Shri Piyush Gupta",
    desc: "823",
    title: "",
    comapny: "M/s Ramayna Ispat Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "284",
    name: "Mr. M.S. Bidasaria",
    desc: "284",
    title: "",
    comapny: "M/s Southern Ferro Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "238",
    name: "Mr. Raja Rajan",
    desc: "238",
    title: "",
    comapny: "M/s N.G.A. Steels Private Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "815 (AS)",
    name: "Er. P. K. Jain Principal Consultant",
    desc: "815 (AS)",
    title: "",
    comapny: "M/s Er. P. K. Jain Principal Consultant",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-56",
    name: "Mr. Rajesh Goyal Mr. Pankaj Khetan",
    desc: "AF-56",
    title: "",
    comapny: "M/s Meenakshi Enterprises",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-52",
    name: "Mr. G.L. Grover (Dir) Mr. Sumit Grover (M.D.)",
    desc: "AF-52",
    title: "",
    comapny: "M/s Vinod International",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "467",
    name: "Mr. S.M. Jain",
    desc: "467",
    title: "",
    comapny: "C/o Venus Alloys (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "716",
    name: "Mr. Ramesh Chand Goyal, MD",
    desc: "716",
    title: "",
    comapny: "M/s BDG Metal & Power Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-ramesh-chand-goyal.jpg",
  },
  {
    id: "826",
    name: "Mr. Navneet Goyal",
    desc: "826",
    title: "",
    comapny: "M/s Mani Mahesh Ispat Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "768",
    name: "Mr. Vinod Gupta",
    desc: "768",
    title: "",
    comapny: "M/s Mega Steels Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "331",
    name: "Mr. Surender Pal Gupta (Director)",
    desc: "331",
    title: "",
    comapny: "M/s Parvati Pvt. Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "803",
    name: "Mr. Ashutosh Goenka",
    desc: "803",
    title: "",
    company: "M/s MIL steel & Power Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "833",
    name: "Mr. Dilip Goenka, Mg. Partner, Mr. Arun Kumar Sharma, President",
    desc: "833",
    title: "",
    company: "M/s K. D. Iron & Steel Co.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "406",
    name: "Mr. S.S. Agarwal",
    desc: "406",
    title: "",
    company: "M/s Premium Ferro Alloys Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-s-s-agarwal.png",
  },
  {
    id: "308",
    name: "Mr. C. Marappan Managing Director",
    desc: "308",
    title: "",
    company: "M/s Sri Vigneswara Steels Pvt. Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-82",
    name: "Mr. Rajeev T. Doulatramani",
    desc: "AF-82",
    title: "",
    company: "M/s Federal Engineers",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "813",
    name: "Mr. Sanjay Kejriwal Mr. Rajeev Kejriwal",
    desc: "813",
    title: "",
    company: "M/s Rukmini Iron Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-sanjay-kejriwal-mr-rajeev-kejriwal.jpg",
  },
  {
    id: "831",
    name: "Mr. Manish Goyal",
    desc: "831",
    title: "",
    company: "M/s Shree Nakoda Ispat Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-manish-goyal.jpg",
  },
  {
    id: "026",
    name: "Mr. Subash Goenka",
    desc: "026",
    title: "",
    company: "M/s Sarwottam Ispat Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "715",
    name: "Mr. M. Somasundaram (Managing Director) Mr. C.D.Chandraekar",
    desc: "715",
    title: "",
    company: "M/s Amman-Try Sponge & Power Private Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "749",
    name: "Mr. Sanjay Gupta",
    desc: "749",
    title: "",
    company: "M/s Jogindra Castings Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-88",
    name: "Mr. Sudhir Gupta",
    desc: "AF-88",
    title: "",
    company: "M/s Advance Hydrau-Tech (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "723",
    name: "Mr. Pankaj Kumar Agarwal",
    desc: "723",
    title: "",
    company: "M/s Anand Ispat Udyog Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "552",
    name: "Mr. Rameshchandra Gupta",
    desc: "552",
    title: "",
    company: "M/s Dadiji Steels Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "820",
    name: "Mr. Harshvardhan Mittal",
    desc: "820",
    title: "",
    company: "M/s Goa Ispat Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-harshvardhan-mittal.jpg",
  },
  {
    id: "431",
    name: "Mr. Rahul Bansal Executive",
    desc: "431",
    title: "",
    company: "M/s Narbada Steel Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "688",
    name: "Mr. Naresh Garg",
    desc: "688",
    title: "",
    company: "M/s Shri Radha Raman Alloys Pvt.Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-naresh-garg.jpg",
  },
  {
    id: "705",
    name: "Mr. Vinod Gupta Mr. Lokesh Gupta",
    desc: "705",
    title: "",
    company: "M/s Capital Ispat Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "483",
    name: "Mr. Ganesh Tiwari Mr. Vishal Tiwari",
    desc: "483",
    title: "",
    company: "M/s Ganpati Industries Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-ganesh-tiwari-mr-vishal-tiwari.png",
  },
  {
    id: "818 (AS)",
    name: "Mr. Kshitij Chabra Director Mr. Anil Chabra",
    desc: "818 (AS)",
    title: "",
    company: "M/s Royal Trexim Pvt.Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "533",
    name: "Mr. Dev Gupta / Mr. Binny Gupta",
    desc: "533",
    title: "",
    company: "M/s Renny Strips (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-dev-gupta-mr-binny-gupta.jpg",
  },
  {
    id: "AF-25",
    name: "Mr. Niraj Khandelwal",
    desc: "AF-25",
    title: "",
    company: "M/s Manglam Electricals",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "731",
    name: "Mr. Dewaker Jain",
    desc: "731",
    title: "",
    company: "M/s Prime Steel Processors Furnace Division",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-dewaker-jain.jpg",
  },
  {
    id: "612",
    name: "Mr. Amarjit Singh",
    desc: "612",
    title: "",
    company: "M/s Atam Concast Steels (Pvt.) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "701",
    name: "Mr. Ashu Gupta (Dir) Mr. Lalit Bansal",
    desc: "701",
    title: "",
    company: "M/s Shree Balaji Furnaces P.Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "702",
    name: "Mr. Raja Ram Yadav",
    desc: "702",
    title: "",
    company: "M/s Sri Balaji Forgings (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-raja-ram-yadav.jpg",
  },
  {
    id: "839",
    name: "Mr. Vijay Jhanwar (MD)",
    desc: "839",
    title: "",
    company: "M/s Gopal Sponge & Power Pvt. Ltd.,",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "330",
    name: "Mr. M. Chinnasami",
    desc: "330",
    title: "",
    company: "M/s Agni Steels (P) Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "843",
    name: "Mr. Sandeep Jain Director",
    desc: "843",
    title: "",
    company:
      "M/s Rathi Iron & Steel Industries (SMS) (A Unit of Jaideep Ispat & Alloys Pvt. Ltd)",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-sandeep-jain.jpg",
  },
  {
    id: "844",
    name: "Mr. Sushil Kumar Tulsyan Director",
    desc: "844",
    title: "Director",
    company: "M/s Umashakti Steels Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-sushil-kumar-tulsyan.jpg",
  },
  {
    id: "845",
    name: "Mr. Anand Agarwal Director",
    desc: "845",
    title: "",
    company: "M/s Shree Tribhuwan Ispat Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-anand-agarwal.jpg",
  },
  {
    id: "846",
    name: "Mr. Sanjeev Agarwal",
    desc: "846",
    title: "",
    company: "M/s Brijbihari Concast Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-sandeep-agarwal.jpg",
  },
  {
    id: "847",
    name: "Mr. Sanjeev Jindal Director",
    desc: "847",
    title: "",
    company: "M/s Uttranchal Ispat Pvt. Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "848",
    name: "Mr. Tushar Agrawal Director",
    desc: "848",
    title: "",
    company: "M/s BTC Industrial Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "849",
    name: "Mr. Prem Chandra Singh Director",
    desc: "849",
    title: "",
    company: "M/s Bhramari Steels Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "850",
    name: "Mr. Ayush Jindal",
    desc: "850",
    title: "",
    company: "M/s Jindal Rolling Mills Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "851",
    name: "Mr. S.K. Kansal",
    desc: "851",
    title: "",
    company: "M/s Mashiva Steel and Alloys LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "852",
    name: "Mr. Vishal Aggrawal",
    desc: "852",
    title: "",
    company: "M/s Western Stainless Steel LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "822",
    name: "Mr. Rajkumar Daga",
    desc: "822",
    title: "",
    company: "M/s Nikunj Udyog",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "840",
    name: "Mr. Anand Sharma",
    desc: "840",
    title: "",
    company: "M/s Rungta Mines Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "616",
    name: "Mr. K.K. Bhartia",
    desc: "616",
    title: "",
    company: "M/s Raigarh Iron Industries Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "822",
    name: "Mr. Rajkumar Daga",
    desc: "822",
    title: "",
    company: "M/s Nikunj Udyog",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "840",
    name: "Mr. Anand Sharma",
    desc: "840",
    title: "",
    company: "M/s Rungta Mines Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "616",
    name: "Mr. K.K. Bhartia",
    desc: "616",
    title: "",
    company: "M/s Raigarh Iron Industries Ltd-",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "853",
    name: "P. Venkataswamy",
    desc: "853",
    title: "",
    company: "M/s Steel Exchange India Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "(AS 854)",
    name: "Mr. A.K. Sharma",
    desc: "(AS 854)",
    title: "",
    company: "M/sAleph Accreditation & Testing Centre (P) Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "854",
    name: "Mr. Pankaj Khaitan",
    desc: "854",
    title: "",
    company: "M/s Amba Shakti Ispat Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/mr-pankaj-khaitan.jpg",
  },
  {
    id: "855",
    name: "Mr. Ramesh Kumar Goel",
    desc: "855",
    title: "",
    company: "M/s Rasik Industries Unit Indian Securities Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "856",
    name: "Mr. Vijay Kumar Mishra",
    desc: "856",
    title: "",
    company: "M/s Fortune Metals Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "858",
    name: "Mr. Mudit Garg",
    desc: "858",
    title: "",
    company: "M/s Shree Mahakaal Concast Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "859",
    name: "Mr. Madhav Goyal",
    desc: "859",
    title: "",
    company: "M/s LD Goyal Steel Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "860",
    name: "Mr. Vaibhav Adhav",
    desc: "860",
    title: "",
    company: "M/s Bhagyalaxmi Rolling Mill Pvt.Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "861",
    name: "Mr. Gopal Gupta",
    desc: "861",
    title: "",
    company: "M/s Star Steels Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "862",
    name: "Mr. Sanjay Solanki",
    desc: "862",
    title: "",
    company: "M/s Modi Concast Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "863",
    name: "Mr. Rohit Gidwani",
    desc: "863",
    title: "",
    company: "M/s Advance Recycling Solutions LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "864",
    name: "Mr. Sandeep Jain",
    desc: "864",
    title: "",
    company: "M/s Trishala Alloys Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "865",
    name: "Mr. Mohinder Gupta",
    desc: "865",
    title: "",
    company: "M/s Gian Castings Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "866",
    name: "Mr. Harish Singla",
    desc: "866",
    title: "",
    company: "M/s Taksus Steels Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "867",
    name: "Mr. Yogesh Mangi",
    desc: "867",
    title: "",
    company: "M/s Shri Ganpati Body Builders",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "868",
    name: "Mr. Anil Kumar",
    desc: "868",
    title: "",
    company: "M/s Dasmesh Castings Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "869",
    name: "Mr. Sushil Mittal",
    desc: "869",
    title: "",
    company: "M/s Samana Concast",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "870",
    name: "Mr. Pawan Bansal",
    desc: "870",
    title: "",
    company: "M/s Shree Jagdambay Castings Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "871",
    name: "Mr. Bharat Bhushan",
    desc: "871",
    title: "",
    company: "M/s Reby Castings Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "872",
    name: "Mr. Jugal Kishor Jain",
    desc: "872",
    title: "",
    company: "M/s Kesri Steels Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "873",
    name: "Mr. Devendra Kumar Arora",
    desc: "873",
    title: "",
    company: "M/s Young Steels Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "874",
    name: "Mr. Amit Kumar Jain",
    desc: "874",
    title: "",
    company: "M/s Kesri Alloys Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "875",
    name: "Mr. Prem Chandra Singh Pimoli",
    desc: "875",
    title: "",
    company: "M/s Bhramari Steels Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "876",
    name: "Mr. Ashok Bhati",
    desc: "876",
    title: "",
    company: "M/s Jai Bajrang Steel",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "877",
    name: "Mr. Manbir Dager",
    desc: "877",
    title: "",
    company: "M/s Elite Steels Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "878",
    name: "Mr. Harsh Garg",
    desc: "878",
    title: "",
    company: "M/s Shree SBG Steels Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "879",
    name: "Mr. Lalit Bansal",
    desc: "879",
    title: "",
    company: "M/s SBF Ispat Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "876",
    name: "Mr. Nitin Jain",
    desc: "876",
    title: "",
    company: "M/s Jai Bajrang Steel",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "881",
    name: "Mr. Akash Chapadia",
    desc: "881",
    title: "",
    company: "M/s Nobel Incorporation",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "882",
    name: "Mr. Ankit Jindal",
    desc: "",
    title: "882",
    company: "M/s Punjab General Industries Pvt Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },

  {
    id: "883",
    name: "Mr. Rajeev Kejriwal",
    desc: "883",
    title: "",
    company: "M/s Rukmini Iron And Steel",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "884",
    name: "Mr. Amit Gupta Kasaniya",
    desc: "884",
    title: "CEO",
    company: "M/s Hari Iron (India) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "885",
    name: "Mr. Vaibhav Mangla",
    desc: "885",
    title: "Director",
    company: "M/s Mangla Hoists Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "886",
    name: "Mr. Vidhyadhar V Muley",
    desc: "886 ",
    title: "Director",
    company: "M/s Bhagyalaxmi Rolling Mill Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "887",
    name: "Mr. Subhash Chand Agrawal",
    desc: "887",
    title: "",
    company: "M/s Shivali Udyog (I) Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "888",
    name: "Mr. Lokeshji",
    desc: "888",
    title: "Director",
    company: "M/s Om Sai Ram Steel & Alloys Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "889",
    name: "Mr. Dinesh Kantilal Rathi",
    desc: "889",
    title: "",
    company: "M/s Rathi Steel And Metal Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "890",
    name: "Mr. Priyank Diwanka",
    desc: "890",
    title: "Director",
    company: "M/s Diwanka Energy Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "891",
    name: "Mr. Ram Hiralalji Agrawal",
    desc: "891",
    title: "",
    company: "M/s Gajkesari Steels And Alloys Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "892",
    name: "Mr. Suman Saraf",
    desc: "892",
    title: "MD",
    company: "M/s Radha Smelters Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "893",
    name: "Mr. Shravan Aggarwal & Mr. Ravinder Aggarwal",
    desc: "893",
    title: "Director",
    company: "M/s Guardian Castings Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "894",
    name: "Mr. Dinesh Omprakash Agrawal",
    desc: "894",
    title: "",
    company:
      "M/s Jalna Siddhivinayak Alloys Private Limited (Roopam Steel Rolling Mills)",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "895",
    name: "Mr. Amarjit Singh",
    desc: "895",
    title: "",
    company: "M/s Atam Concast Steels (Pvt.) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "896",
    name: "Mr. Ashok Surana",
    desc: "896",
    title: "",
    company: "M/s Shobha Enterprises",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "897",
    name: "Mr. Arjun Gupta",
    desc: "897",
    title: "",
    company: "M/s Shree Sidhabali Ispat Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "898",
    name: "Mr. Narayan Gupta",
    desc: "898",
    title: " Director",
    company: "M/s Rajuri Steels And alloys India Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "899",
    name: "Mr. Chandra Shekhar Choudhary",
    desc: "899",
    title: "",
    company: "M/s Kemo Steel Industries Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "900",
    name: "Mr.Gaurav V Kasat",
    desc: "900",
    title: "Director",
    company: "M/s Varad Ferro Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "901",
    name: "Ms. Vrushika Gujar",
    desc: "901",
    title: "",
    company: "M/s Agrasha Alloys & Metals Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "902",
    name: "Mr. Sanjay Mehta",
    desc: "902",
    title: "",
    company: "M/s MTC Business Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "903",
    name: "Mr. Kaushubh K Loya",
    desc: "903",
    title: "",
    company: "M/s Rajuri Steels and TMT Bar Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "904",
    name: "Mr. Kaushubh K Loya",
    desc: "904",
    title: "",
    company: "M/s Rajuri Steels and TMT Bar Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "905",
    name: "Mr. Ramesh Kumar Agrawal",
    desc: "905",
    title: "",
    company: "M/s G. R. Sponge And Power Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "906",
    name: "Mr. Hareshbhai Patel",
    desc: "906",
    title: "",
    company: "M/s Sachdeva Industries Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "907",
    name: "Mr. Mohit Mardia",
    desc: "907",
    title: "MD",
    company: "M/s Grace Castings Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "908",
    name: "Mr. Javed Lakhani Partner",
    desc: "908",
    title: "",
    company: "M/s Raj Ispat",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "909",
    name: "Mr. Prakash Bhai Doshi",
    desc: "909",
    title: "",
    company: "M/s Priti Marine Pvt. Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "910",
    name: "Mr. Vasant Bhai & Mr. Praksh Bhai K Patel",
    desc: "910",
    title: "",
    company: "M/s Vinayak TMT Bars Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "911",
    name: "Mr. Irfan Mohammedfirdos Kothi",
    desc: "911",
    title: "",
    company: "M/s Kothi Steel Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "912",
    name: "Mr. Devendra Patel",
    desc: "912",
    title: "",
    company: "M/s Optel Metals Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "913",
    name: "Mr. Maheshbhai Patel",
    desc: "913",
    title: "",
    company: "M/s Ganesh Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "914",
    name: "Mr. Rakesh Patel",
    desc: "914",
    title: "Partner",
    company: "M/s Swastik Concast",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "915",
    name: "Mr. Utsav Patel",
    desc: "915",
    title: "",
    company: "M/s Maheshwar Steel Cast",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "916",
    name: "Mr. Krupkesh Kumar R Patel",
    desc: "916",
    title: "",
    company: "M/s Kepco Alloys Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "917",
    name: "Mr. Patel HiralKumar Punja Bhai",
    desc: "917",
    title: "",
    company: "M/s Mangalmurti Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "918",
    name: "Mr. Patel Atulkumar Jagdish Bha",
    desc: "918",
    title: "",
    company: "M/s Varahi Concast",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "919",
    name: "Mr. Chirag Patel",
    desc: "919",
    title: "",
    company: "M/s Jay Metal",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "920",
    name: "Mr. Kiran Bhai Patel",
    desc: "920",
    title: "",
    company: "M/s Pramukh Industries",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "921",
    name: "Mr. Pankaj Kumar Popat Bhai Patel",
    desc: "921",
    title: "",
    company: "M/s Kapoor Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "922",
    name: "Mr. Nirav Kumar Patel",
    desc: "922",
    title: "",
    company: "M/s Shlok Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "923",
    name: "Mr. Patel Bhargan Kumar Jotta Bhai",
    desc: "923",
    title: "",
    company: "M/s Om Metal",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "924",
    name: "Mr. Virat Kumar Patel",
    desc: "924",
    title: "",
    company: "M/s Somdeep Alloys Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "925",
    name: "Mr. Chintan Patel Vikrant Patel",
    desc: "925",
    title: "",
    company: "M/s Umiya Cast LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "926",
    name: "Mr. Priyank Patel",
    desc: "926",
    title: "",
    company: "M/s Dhanraj Metals",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "927",
    name: "Mr. Jayesh Bhai Patel",
    desc: "927",
    title: "",
    company: "M/s Niyon Ispat LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "928",
    name: "Mr. Bharat Bhai patel & Mr. Haresh Bhai Patel",
    desc: "928",
    title: "",
    company: "M/s Kapson Iron and Steel LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "929",
    name: "Mr. Sudesh Sharma",
    desc: "929",
    title: "",
    company: "M/s Shri Prithvi Alloys Pvt ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "930",
    name: "Mr. Patel Dipak Kumar Mahesh Bhai",
    desc: "930",
    title: "",
    company: "M/s Ved Concast",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "931",
    name: "Mr. Hemant R Nora",
    desc: "931",
    title: "",
    company: "M/s KB Ispat Pvt Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "932",
    name: "Mr. Girish Bhai Falji Bhai Patel,",
    desc: "932",
    title: "Director",
    company: "M/s Vireshvar Iron And Steel Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "933",
    name: "Mr. Patel Shekhar Kumar",
    desc: "933",
    title: "",
    company: "M/s Mahadev Metals",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "934",
    name: "Mr. Ketan Patel",
    desc: "934",
    title: "",
    company: "M/s Deep Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "935",
    name: "Mr. Nitin Rumii Bhai Patel",
    desc: "935",
    title: "",
    company: "M/s Sanwariya Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "936",
    name: "M/s Kesari Ispat LLP  ",
    desc: "936",
    title: "",
    company: "M/s Kesari Ispat LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "937",
    name: "Mr. Anjum Lakhani",
    desc: "937",
    title: "",
    company: "M/s Elaf Steel",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "938",
    name: "Mr. Kalva Abdulkadar Arif Bhai",
    desc: "938",
    title: "",
    company: "M/s Mirya Industries",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "939",
    name: "Mr. Bipin Patel",
    desc: "939",
    title: "",
    company: "M/s Shiv Metals",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "940",
    name: "Mr. Patel Mukund Bhai Ji",
    desc: "940",
    title: "",
    company: "M/s Dev Metals",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "941",
    name: "Mr. Tapan Khandelwal",
    desc: "941",
    title: "",
    company: "M/s Maharashtra Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "942",
    name: "Mr. Mahednra Patel",
    desc: "942",
    title: "",
    company: "Mr. Pavn Patel",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "943",
    name: "Mr. Mohmadabid Bhala",
    desc: "943",
    title: "",
    company: "Mr. Adil Bhala",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "944",
    name: "Mr. Taufiq I Marfani",
    desc: "944",
    title: "",
    company: "M/s Salsabil Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "945",
    name: "Mr. Anas Lakhani",
    desc: "945",
    title: "",
    company: "M/s Falah Ispat",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "946",
    name: "Mr. Lakhani Ovezarif Bhai",
    desc: "946",
    title: "",
    company: "M/s Capital Ispat",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "947",
    name: "M/s Husain Sheth Industries",
    desc: "947",
    title: "",
    company: "M/s Husain Sheth Industries",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "948",
    name: "Mr. Abdul Mannan Zuber Vgau Hami Dani & Mr. Javedbhai Mohammad Safi Bhai Hami Dani",
    desc: "948",
    title: "",
    company: "M/s Hilal Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "949",
    name: "Mr. Rathod Sanjay Kumar Harbhad Bhai",
    desc: "949",
    title: "Director",
    company: "M/s Sanjay Castings (India)PVt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "950",
    name: "M/s Sunrise Multi Steel Private Limited",
    desc: "950",
    title: "",
    company: "M/s Sunrise Multi Steel Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "951",
    name: "Mr. Ashok Bhai Pael & Mr. Ashvin Bhai Patel",
    desc: "951",
    title: "",
    company: "M/s Kapton Alloys Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "952",
    name: "Mr. Sufiyan Malkani",
    desc: "952",
    title: "",
    company: "M/s Malkani Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "953",
    name: "Mr. Dhairik Fuletra",
    desc: "953",
    title: "",
    company: "M/s Fuletra Steel LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "954",
    name: "Mr. Shailesh M Patel",
    desc: "954",
    title: "",
    company: "M/s Smak Steel LLP",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "955",
    name: "Mr. Jay Limbani",
    desc: "955",
    title: "",
    company: "M/s Limbani Steel Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "956",
    name: "Mr. Vinit Ved",
    desc: "956",
    title: "",
    company: "M/s Vallabh Ispat",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "957",
    name: "Mr. Shiv Narayan Bansal",
    desc: "957",
    title: "",
    company: "M/s Sai Bandhan Infinium Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "958",
    name: "Mr. Smit Shah",
    desc: "958",
    title: "",
    company: "M/s Prabodh Steel Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "959",
    name: "Mr. Sushil Jajoo",
    desc: "959",
    title: "",
    company: "M/s Jajoo Exim Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "960",
    name: "Mr. Manish Agarwal & Mr. Ashish Agarwal",
    desc: "960",
    title: "",
    company: "M/s Shri Khatu Shyam Alloys Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "961",
    name: "Mr. Megh Raj Garg",
    desc: "961",
    title: "",
    company: "M/s H. M. Steels Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "962",
    name: "Mr. Megh Raj Garg",
    desc: "962",
    title: "",
    company: "M/s Prime Steel Industries Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "963",
    name: "Mr. Sahil Patel,Mr. Salin Patel & Mr. Indrvadan Patel",
    desc: "963",
    title: "",
    company: "M/s Vivan Steels & Alloys Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-964",
    name: "Mr. Sashikant Agarwal",
    desc: "AF-964",
    title: "",
    company: "M/s Sri Navdurga Billets Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-965",
    name: "Mr. Vinod Kumar Agarwal",
    desc: "AF-965",
    title: "",
    company: "M/s Salasar Iron And Steel Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "966",
    name: "Mr. Jullian Jallan",
    desc: "966",
    title: "",
    company: "M/s A-One Steel & Alloys Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "967",
    name: "Mr. Shah Faisal Rana",
    desc: "967",
    title: "",
    company: "M/s Aman Rolling Mills Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "968",
    name: "Mr. Kamal Goyal",
    desc: "968",
    title: "",
    company: "M/s Amba Shakti Industries Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "969",
    name: "Mr. Harsh Choudhry",
    desc: "969",
    title: "",
    company: "M/S Sentra World Technologies Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "970",
    name: "Mr. Anish J Malvania",
    desc: "970",
    title: "",
    company: "M/s Indtech Marketing",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "971",
    name: "Mr. Hemant Lunia",
    desc: "971",
    title: "",
    company: "M/s Balaji Niryaat Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "972",
    name: "Mr. Ram Prakash Malpani",
    desc: "972",
    title: "",
    company: "Jay Jagdamba Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "973",
    name: "Mr. Haushikesh KS",
    desc: "973",
    title: "",
    company: "Finecrafts Steel & Power Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "974",
    name: "Mr. R. Abdulsattar I. Kalva",
    desc: "974",
    title: "",
    company: "H. K. Enterprise & Sons",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "975",
    name: "Mr. Jalpesh Shah",
    desc: "975",
    title: "",
    company: "CTC Impex (India) Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "976",
    name: "Mr. Vivek Bansal Prashant Agarwal",
    desc: "976",
    title: "",
    company: "Infinity Steel & Alloys",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "977",
    name: "Mr. Mayur Jain",
    desc: "977",
    title: "",
    company: "Bharitya Metcast Pvt. Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "978",
    name: "Mr. Prakash Goenka",
    desc: "978",
    title: "",
    company: "Devashree Ispat Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "979",
    name: "Mr. Navin Bhuwalka",
    desc: "979",
    title: "",
    company: "SRMB Srijan Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-980",
    name: "Mr. Abhishek Goyal",
    desc: "AF-980",
    title: "",
    company: "Industrial Supplies & Solutions Company",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "981",
    name: "Mr. Sunil Tulsyan Abhijit Barui",
    desc: "981",
    title: "",
    company: "Captain Steel India Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "982",
    name: "Mr. Avinash Vyas",
    desc: "982",
    title: "",
    company: "HUV Industries",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "983",
    name: "Mr. Javad Lakhani Amaan Lakhani",
    desc: "983",
    title: "",
    company: "JK Ispat",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "984",
    name: "Mr. B. L. Gupta",
    desc: "984",
    title: "",
    company: "Jagdamba TMT Mills Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "985",
    name: "Mr. Patel Shekhar Kumar Dahya Bhai",
    desc: "985",
    title: "",
    company: "Rudra Metals",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "986",
    name: "Mr. Anshul Kumar Chandwani",
    desc: "986",
    title: "Director",
    company: "Hoin Mal Sons Enterprises Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-987",
    name: "Mr. Shailendra Arora Praveen Rajput",
    desc: "AF-987",
    title: "Director",
    company: "SG Mart Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "988",
    name: "Mr. Hemant Jindal",
    desc: "988",
    title: "Director",
    company: "Metro Bright Bar (India) Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-989",
    name: "Dr Sarbendu Sanyal",
    desc: "AF-989",
    title: "Chief Technology Officer ",
    company: "Jamipol Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-990",
    name: "Mr. Shaurya Roy",
    desc: "AF-990",
    title: "MD",
    company: "Shri Balaji Impex",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-991",
    name: "Mr. Srinivas Venkoba Kallakurchi",
    desc: "AF-991",
    title: "Director",
    company: "Choice Solutions Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "AF-992",
    name: "Mr. Dinesh Agarwal",
    desc: "AF-992",
    title: "MD",
    company: "Nature Eco Building Pvt. Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "993",
    name: "Mr. Shrikant Shankar Badve",
    desc: "993",
    title: "MD",
    company: "Sumedh Tools Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "994",
    name: "Mr. Shrikant Shankar Badve",
    desc: "994",
    title: "MD",
    company: "Eximiius Autocomps Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "995",
    name: "Mr. Vishwa Shriwastava",
    desc: "995",
    title: "Director",
    company: "ShriSons Revival Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "996",
    name: "Mr. Rajat Rajesh Sarda",
    desc: "996",
    title: "Director",
    company: "Ramsons Industries Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "997",
    name: "Mr. Shivkant Choudhary",
    desc: "997",
    title: "GM-Commercial",
    company: "Narbheram Power and Steel Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "998",
    name: "Mr. Nilesh Damani",
    desc: "998",
    title: "Director",
    company: "Damani Castings Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "999",
    name: "Mr. Gaurav Jajodia",
    desc: "999",
    title: "Director",
    company: "Jai Balaji Industries Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1000",
    name: "Mr. Hari Prakash Poras",
    desc: "1000",
    title: "AVP - Taxation",
    company: "Evonith Value Steel Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1001",
    name: "Mr. Harish Ahuja",
    desc: "1001",
    title: "Sr. Mg Cor Comm",
    company: "Viraj Profiles Pvt Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1002",
    name: "Mr. Vipin Gupta",
    desc: "1002",
    title: "Director",
    company: "Dinanath Allied Steel Manufacturing Private Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1003",
    name: "Mr. Pankaj Khetan",
    desc: "1003",
    title: "MD",
    company: "Sponge Sales India Pvt Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1004",
    name: "Mr. Shanti Lal G. Peety",
    desc: "1004",
    title: "MD",
    company: "SRJ Peety Steels (P) Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1005",
    name: "Mr. Vineet Kedia",
    desc: "1005",
    title: "MD",
    company: "Vinayak Steels Limited",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1006",
    name: "Mr. Sumit Agrawal",
    desc: "1006",
    title: "AVP",
    company: "Lloyds Metal And Energy Ltd",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1007",
    name: "Mr. Harshit Maheshwari",
    desc: "1007",
    title: "MD & CEO",
    company: "Gajanan Minchem Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "1008",
    name: "Mr. Nilesh Bhattad",
    desc: "1008",
    title: "CEO and Director",
    company: "Thinksmart Technologies Pvt. Ltd.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
  {
    id: "SM 1009",
    name: "Mr. Arun Pal",
    desc: "SM 1009",
    title: "New Business Development Manager",
    company: "Rotar International B. V.",
    img: "http://hoverbusinessservices.com/cloud/aiifa/media/members/user.png",
  },
];

export default function ActiveMembers() {
 const [searchTerm, setSearchTerm] = useState("");

const filteredMembers = ActiveMember.filter(
  (member) =>
    (member.name ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (member.company ?? "").toLowerCase().includes(searchTerm.toLowerCase())
);

  return (
    <>
      <section className="our-team-section">
        <div className="our-team-container">
          <p className="our-team-subtitle mb-4">Active MEMBER</p>
          {/* <h2 className="our-team-title text-white">Our Team</h2> */}

          {/* Search Bar */}

          {/* ✅ Search Bar */}
          <div className="our-team-search-wrapper">
            <div className="our-team-search-box">
              <Search size={18} className="our-team-search-icon" />
              <input
                type="text"
                placeholder="Search by name or company..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="our-team-search-input"
              />
            </div>
          </div>
          <div className="our-team-grid">
            {filteredMembers.map((member, index) => (
              <div className="our-team-flip-card" key={index}>
                <div className="our-team-flip-inner">
                  {/* FRONT SIDE */}
                  <div className="our-team-flip-front">
                    <div className="our-team-img-wrapper">
                      <img
                        src={member.img}
                        alt={member.name}
                        className="our-team-img"
                      />
                    </div>
                    <h4 className="our-team-name">{member.name}</h4>
                    <p className="our-team-role">{member.title}</p>
                    {member.subtitle && (
                      <p className="our-team-subtitle-br">{member.subtitle}</p>
                    )}
                    <p className="our-team-company">{member.company}</p>
                    <p className="our-team-company">{member.id}</p>
                  </div>

                  {/* BACK SIDE */}
                  <div className="our-team-flip-back">
                    <h4>{member.name}</h4>
                    <p>
                      <strong>Role:</strong> {member.title}
                    </p>
                    {member.subtitle && <p>{member.subtitle}</p>}
                    <p>
                      <strong>Company:</strong> {member.company}
                    </p>

                    {/* ✅ You can add anything here later */}
                    <p className="flip-note">AIIFA National Member</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
